import AddIcon from '@mui/icons-material/Add'
import { Button } from '@mui/material'
import type React from 'react'
import { type ReactNode, useEffect, useState } from 'react'
import { useAuth } from '../hooks/useAuth'
import { ModalDeviceAddDialog } from './ModalDeviceAddDialog'

type DeviceAddButtonProps = {
  children: ReactNode
  title: string
  onAdd: (
    rhq: string,
    salesCompany: string,
    loginId: string,
    password: string,
    apiKey: string,
    serial: string,
  ) => void
}

export const DeviceAddButton: React.FC<DeviceAddButtonProps> = props => {
  const { onAdd } = props
  const auth = useAuth()
  const [open, setOpen] = useState(false)
  const [rhq, setRhq] = useState('')
  const [salesCompany, setSalesCompany] = useState('')
  const [loginId, setLoginId] = useState('')
  const [password, setPassword] = useState('')
  const [apiKey, setApiKey] = useState('')
  const [serial, setSerial] = useState('')

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleSave = (
    salesCompany: string,
    loginIdlValue: string,
    passwordlValue: string,
    apiKeylValue: string,
    serialValue: string,
  ) => {
    setRhq(auth.rhq)
    setSalesCompany(salesCompany)
    setLoginId(loginIdlValue)
    setPassword(passwordlValue)
    setApiKey(apiKeylValue)
    setSerial(serialValue)
  }

  const onClickHandler = async () => {
    handleOpen()
  }
  useEffect(() => {
    if (
      salesCompany !== '' &&
      loginId !== '' &&
      password !== '' &&
      apiKey !== '' &&
      serial !== ''
    ) {
      onAdd(rhq, salesCompany, loginId, password, apiKey, serial)
      setSalesCompany('')
      setLoginId('')
      setPassword('')
      setApiKey('')
      setSerial('')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [salesCompany, loginId, password, apiKey, serial])

  //多言語化対応
  const userLanguage = navigator.language || navigator.languages[0]
  const baseLanguage = userLanguage.split('-')[0]
  let deviceAddButtonJsx: JSX.Element
  switch (baseLanguage) {
    case 'de':
    case 'sv':
      deviceAddButtonJsx = (
        <Button
          disabled={auth.isDisable}
          onClick={onClickHandler}
          startIcon={<AddIcon sx={{ width: 40, height: 40, paddingBottom: '6px' }} />}
          sx={{
            justifyContent: 'center',
            alignContent: 'center',
            color: '#282828',
            font: 'normal normal bold 21px/32px Noto Sans JP',
            paddingTop: '6px',
            backgroundColor: '#fff16f',
            '&:hover': {
              backgroundColor: 'rgba(255, 241, 111, 0.8)',
            },
            boxShadow: '0px 2px 2px #00000014',
            height: '80px',
            width: '250px',
            borderRadius: '40px',
            '& .MuiSvgIcon-root': {
              fontSize: '32px',
            },
          }}
        >
          {props.children}
        </Button>
      )
      break
    default:
      deviceAddButtonJsx = (
        <Button
          disabled={auth.isDisable}
          onClick={onClickHandler}
          startIcon={<AddIcon sx={{ width: 40, height: 40, paddingBottom: '6px' }} />}
          sx={{
            justifyContent: 'center',
            alignContent: 'center',
            color: '#282828',
            font: 'normal normal bold 21px/32px Noto Sans JP',
            paddingTop: '6px',
            backgroundColor: '#fff16f',
            '&:hover': {
              backgroundColor: 'rgba(255, 241, 111, 0.8)',
            },
            boxShadow: '0px 2px 2px #00000014',
            height: '80px',
            width: '200px',
            borderRadius: '40px',
            '& .MuiSvgIcon-root': {
              fontSize: '32px',
            },
          }}
        >
          {props.children}
        </Button>
      )
      break
  }
  return (
    <>
      {open && (
        <ModalDeviceAddDialog
          open={open}
          title={props.title}
          onClose={handleClose}
          onSave={handleSave}
        />
      )}
      {deviceAddButtonJsx}
    </>
  )
}
